import request from '@/utils/request'

export function getUserAddressOrderList(data) {
    return request({
        url: '/backend/course/getUserAddressOrderList',
        method: 'post',
        data: data
    })
}

export function getSubscribeList(data) {
    return request({
        url: '/backend/course/getSubscribeList',
        method: 'post',
        data: data
    })
}

export function getPeriodList(data) {
    return request({
        url: '/backend/course/getPeriodList',
        method: 'post',
        data: data
    })
}

export function deletePeriod(data) {
    return request({
        url: '/backend/course/deletePeriod',
        method: 'post',
        data: data
    })
}
export function updateStatusPeriod(data) {
    return request({
        url: '/backend/course/updateStatusPeriod',
        method: 'post',
        data: data
    })
}

export function updateSortPeriod(data) {
    return request({
        url: '/backend/course/updateSortPeriod',
        method: 'post',
        data: data
    })
}

export function baiJiaYunVideoCreatePeriod(data) {
    return request({
        url: '/backend/course/baiJiaYunVideoCreatePeriod',
        method: 'post',
        data: data
    })
}

export function getCourseTermList(data) {
    return request({
        url: '/backend/course/getCourseTermList',
        method: 'post',
        data: data
    })
}

export function changeCourseAttribute (data) {
    return request({
        url: '/backend/course/changeCourseAttribute',
        method: 'post',
        data: data
    })
}

export function evaluationList (data) {
    return request({
        url: '/backend/course/evaluation/getList',
        method: 'post',
        data: data
    })
}

export function evaluationStatus (data) {
    return request({
        url: '/backend/course/evaluation/updateStatus',
        method: 'post',
        data: data
    })
}

//进阶计划
export function advancePlanList (data) {
    return request({
        url: '/backend/course/advance-plan/list',
        method: 'get',
        params: data
    })
}
export function advancePlanCreateUpdate (data) {
    return request({
        url: '/backend/course/advance-plan/create/update',
        method: 'post',
        data: data
    })
}
export function advancePlanStatus (data) {
    return request({
        url: '/backend/course/advance-plan/status/update',
        method: 'post',
        data: data
    })
}
export function advancePlanDel (data) {
    return request({
        url: '/backend/course/advance-plan/del',
        method: 'post',
        data: data
    })
}
export function advancePlanCourseList (data) {
    return request({
        url: '/backend/course/advance-plan/course/list',
        method: 'get',
        params: data
    })
}
export function advancePlanCourseCoverImage (data) {
    return request({
        url: '/backend/course/advance-plan/course-cover/update',
        method: 'post',
        data: data
    })
}
export function advancePlanRelationshipDel (data) {
    return request({
        url: '/backend/course/advance-plan/course/del',
        method: 'post',
        data: data
    })
}

//获取所有的课程列表，剔除已经关联的
export function advancePlanAllCourseList (data) {
    return request({
        url: '/backend/course/advance-plan/all-course/list',
        method: 'get',
        params: data
    })
}

//添加进阶计划关联课程
export function addAdvancePlanCourse (data) {
    return request({
        url: '/backend/course/advance-plan/course/add',
        method: 'post',
        params: data
    })
}